<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-notEqual`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.54297 2.21959C9.67662 1.87763 10.0623 1.70912 10.4043 1.84264C10.7464 1.97626 10.9158 2.36188 10.7822 2.70397L10.1953 4.20788H13.1943C13.5616 4.20788 13.8594 4.50565 13.8594 4.87292C13.8593 5.24012 13.5616 5.53795 13.1943 5.53795H9.67578L7.75391 10.4579H13.1943C13.5616 10.4579 13.8594 10.7556 13.8594 11.1229C13.8593 11.4901 13.5616 11.788 13.1943 11.788H7.23438L6.45703 13.7782C6.32327 14.12 5.93765 14.2886 5.5957 14.1551C5.25387 14.0214 5.08528 13.6358 5.21875 13.2938L5.80664 11.788H2.80566C2.43844 11.788 2.1407 11.4901 2.14062 11.1229C2.14062 10.7556 2.43839 10.4579 2.80566 10.4579H6.32617L8.24707 5.53795H2.80566C2.43844 5.53795 2.1407 5.24012 2.14062 4.87292C2.14062 4.50565 2.43839 4.20788 2.80566 4.20788H8.7666L9.54297 2.21959Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineNotEqual',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
